import { atom, useAtom, useSetAtom } from 'jotai';

const isPredictivePlanningModeActive = atom(false);

export const usePredictivePlanningMode = () => {
  const [isActive] = useAtom(isPredictivePlanningModeActive);
  return isActive;
};

export const useSetPredictivePlanningMode = () => {
  return useSetAtom(isPredictivePlanningModeActive);
};
